import { render, staticRenderFns } from "./HeadTraitPreview.vue?vue&type=template&id=33a62dc2&scoped=true&"
import script from "./HeadTraitPreview.vue?vue&type=script&lang=ts&"
export * from "./HeadTraitPreview.vue?vue&type=script&lang=ts&"
import style0 from "./HeadTraitPreview.vue?vue&type=style&index=0&id=33a62dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a62dc2",
  null
  
)

export default component.exports